module.exports = __webpack_public_path__ + "media/images/video-ae48e88ca441ffbf7551a94d5e62c24e.jpg";